var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"input-group-alternative"},[_c('textarea',{attrs:{"id":"editor","name":"editor"},on:{"change":_vm.valueChange}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }